import { apiProvider } from './utilities/Provider';

// Remembered-device token (skips 2FA for 30 days); kept per account across logouts.
const trustedDeviceKey = (email) => `trustedDevice:${(email ?? '').trim().toLowerCase()}`;

const storeTrustedDevice = (email) => (result) => {
    if (result?.trustedDeviceToken) localStorage.setItem(trustedDeviceKey(email), result.trustedDeviceToken);
    return result;
};

const login = (email, password) =>
    apiProvider.post('agency/account/login', {
        email,
        password,
        trustedDeviceToken: localStorage.getItem(trustedDeviceKey(email)),
    });

const getMe = () =>
    apiProvider.get('users/me');

const getProfile = () =>
    apiProvider.get('agency/account/me');

const updateProfile = (data) =>
    apiProvider.put('agency/account/me', data);

const changePassword = (currentPassword, newPassword) =>
    apiProvider.post('agency/account/change-password', { currentPassword, newPassword });

const setupTwoFactor = () =>
    apiProvider.post('agency/account/2fa/setup');

const storeToken = (result) => {
    if (result?.token) localStorage.setItem('token', result.token);
    return result;
};

const confirmTwoFactor = (code) =>
    apiProvider.post('agency/account/2fa/confirm', { code }).then(storeToken);

const disableTwoFactor = ({ password, code }) =>
    apiProvider.post('agency/account/2fa/disable', { password, code });

const verifyTwoFactorLogin = (pendingToken, code, email) =>
    apiProvider.post('agency/account/2fa/verify-login', { pendingToken, code }).then(storeTrustedDevice(email));

const resendTwoFactorLoginCode = (pendingToken) =>
    apiProvider.post('agency/account/2fa/resend-login-code', { pendingToken });

const sendEmailTwoFactorSetupCode = () =>
    apiProvider.post('agency/account/2fa/email/send-code');

const confirmEmailTwoFactor = (code) =>
    apiProvider.post('agency/account/2fa/email/confirm', { code }).then(storeToken);

const requestTwoFactorReset = (email, password) =>
    apiProvider.post('agency/account/2fa/reset/request', { email, password });

const confirmTwoFactorReset = (email, code) =>
    apiProvider.post('agency/account/2fa/reset/confirm', { email, code });

const getChatConsents = () =>
    apiProvider.get('agency/account/chat-consents');

const updateChatConsents = (data) =>
    apiProvider.put('agency/account/chat-consents', data);

const getChatConsentHistory = () =>
    apiProvider.get('agency/account/chat-consents/history');

const getBranding = () =>
    apiProvider.get('agency/account/branding');

const updateBranding = (data) =>
    apiProvider.put('agency/account/branding', data);

const uploadBrandingLogo = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiProvider.postMultipart('agency/account/branding/logo', formData);
};

const deleteBrandingLogo = () =>
    apiProvider.remove('agency/account/branding', 'logo');

const updateScoring = (enabled) =>
    apiProvider.put('agency/account/scoring', { enabled });

const AccountService = {
    login,
    requestTwoFactorReset,
    confirmTwoFactorReset,
    getMe,
    getProfile,
    updateProfile,
    changePassword,
    setupTwoFactor,
    confirmTwoFactor,
    disableTwoFactor,
    verifyTwoFactorLogin,
    resendTwoFactorLoginCode,
    sendEmailTwoFactorSetupCode,
    confirmEmailTwoFactor,
    getChatConsents,
    updateChatConsents,
    getChatConsentHistory,
    getBranding,
    updateBranding,
    uploadBrandingLogo,
    deleteBrandingLogo,
    updateScoring,
};

export default AccountService;
